"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformArguments = exports.IS_READ_ONLY = void 0;
exports.IS_READ_ONLY = true;
function transformArguments(section) {
    const args = ['INFO'];
    if (section) {
        args.push(section);
    }
    return args;
}
exports.transformArguments = transformArguments;
